export const mutations = {
  setDemands: (state, data) => (state.demands = data),
  setDemand: (state, data) => (state.demand = data),
  setTotalPages: (state, totalPages) => (state.totalPages = totalPages),
  setCurrentPage: (state, currentPage) => (state.currentPage = currentPage),
  setDemandStatuses: (state, statuses) => (state.demandStatuses = statuses)
}
